export enum OtherList {
  Notification = 'Notification'
}
